import { BaseSerializer } from './base.serializer'
import { Session } from 'models/session.model'
import { DateSerializer, TimeSerializer } from './attributes'
import { DriverSerializer } from './driver.serializer'
import { ExamSerializer } from './exam.serializer'
import { SessionInfractionSerializer } from './session-infraction.serializer'
import { ModeratedInfractionSerializer } from './moderated-infraction.serializer'
import { SessionInteractiveSerializer } from './session-interactive.serializer'
import { PhotoSerializer } from './photo.serializer'
import { DocumentSerializer } from './document.serializer'
import { DriverLicenseSerializer } from './driver-license.serializer'
import { CenterSerializer } from './center.serializer'
import { ProgramSerializer } from './program.serializer'
import { UserSerializer } from './user.serializer'
import { SessionWarningSerializer } from './session-warning.serializer'
import { InterviewSerializer, InterviewResultlSerializer } from './interview.serializer'

/**
 * Нужен для преобразования сессии в правильный атрибуты для принятия сессии интервьюером
 */
export class SessionInterviewerFinishSerializer extends BaseSerializer<Session> {
  static SERIALIZABLE_ATTRIBUTES = [
    'interviewResult', 'interviewerComment', 'sessionInterviewInfractions'
  ]
  static SERIALIZERS = {
    interviewResult: InterviewResultlSerializer,
    sessionInterviewInfractions: SessionInfractionSerializer
  }
  static SERIALIZE_RENAME_KEYS = {
    sessionInterviewInfractions: 'sessionInterviewInfractionsAttributes',
    interviewResult: 'interviewResultAttributes'
  }
}

export class SessionSerializer extends BaseSerializer<Session> {
  static SERIALIZABLE_ATTRIBUTES = [
    'accessorComment', 'videoaccessorComment', 'moderatorComment', 'accessorPhotos', 'videoaccessorPhotos',
    'additionalLicensePhotos', 'additionalPassportPhotos','additionalPortraitPhotos',
    'birthdate', 'firstname', 'lastname', 'licenseIssuedAt', 'licenseNumber', 'middlename', 'phone',
    'sessionInfractions', 'moderatedInfractions', 'document', 'driverLicense', 'sessionInteractives', 
    'center', 'program', 'videoaccessor', 'moderator', 'moderator_approval_state',
    'videoaccessor_approval_state', 'videoaccessor_autoapproved', 'has_exam', 'sessionWarning', 
    'interviewerComment', 'interview_state', 'need_interview', 'sessionInterviewInfractions', 
    'app_version', 'withPremium', 'exam', 'centerProgram'
  ]

  static SERIALIZERS = {
    accessorPhotos: PhotoSerializer,
    videoaccessorPhotos: PhotoSerializer,
    additionalLicensePhotos: PhotoSerializer,
    additionalPassportPhotos: PhotoSerializer,
    additionalPortraitPhotos: PhotoSerializer,
    birthdate: DateSerializer,
    licenseIssuedAt: DateSerializer,
    sessionInfractions: SessionInfractionSerializer,
    moderatedInfractions: ModeratedInfractionSerializer,
    document: DocumentSerializer,
    driverLicense: DriverLicenseSerializer,
    center: CenterSerializer,
    program: ProgramSerializer,
    videoaccessor: UserSerializer,
    interviewer: UserSerializer,
    sessionInterviewInfractions: SessionInfractionSerializer,
    moderator: UserSerializer,
    exam: ExamSerializer,
    interview: InterviewSerializer,
    interviewResult: InterviewResultlSerializer,
  }

  static SERIALIZE_RENAME_KEYS = {
    accessorPhotos: 'accessorPhotosAttributes',
    videoaccessorPhotos: 'videoaccessorPhotosAttributes',
    additionalLicensePhotos: 'additionalLicensePhotosAttributes',
    additionalPassportPhotos: 'additionalPassportPhotosAttributes',
    additionalPortraitPhotos: 'additionalPortraitPhotosAttributes',
    sessionInfractions: 'sessionInfractionsAttributes',
    sessionInterviewInfractions: 'sessionInterviewInfractionsAttributes',
    moderatedInfractions: 'moderatedInfractionsAttributes',
    interviewResult: 'interviewResultAttributes'
  }

  static DESERIALIZERS = {
    accessorPhotos: PhotoSerializer,
    videoaccessorPhotos: PhotoSerializer,
    additionalLicensePhotos: PhotoSerializer,
    additionalPassportPhotos: PhotoSerializer,
    additionalPortraitPhotos: PhotoSerializer,
    birthdate: DateSerializer,
    completedAt: TimeSerializer,
    controlPhotos: PhotoSerializer,
    createdAt: TimeSerializer,
    driver: DriverSerializer,
    exam: ExamSerializer,
    sessionInfractions: SessionInfractionSerializer,
    moderatedInfractions: ModeratedInfractionSerializer,
    licenseIssuedAt: DateSerializer,
    licensePhoto: PhotoSerializer,
    passportPhoto: PhotoSerializer,
    portraitPhoto: PhotoSerializer,
    document: DocumentSerializer,
    driverLicense: DriverLicenseSerializer,
    sessionInteractives: SessionInteractiveSerializer,
    sessionWarnings: SessionWarningSerializer,
    examStartedAt: TimeSerializer,
    sessionInterviewInfractions: SessionInfractionSerializer,
    exportDate: TimeSerializer,
    interview: InterviewSerializer,
    interviewResult: InterviewResultlSerializer,
  }
  static DESERIALIZE_RENAME_KEYS = {}

  static initializeObject(attributes: Object): Session {
    return new Session(attributes)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/session.serializer.ts